<template>
    <div class="unit">
        <!-- 头部介绍 -->
        <div class="unit-header">
            <span>施工单位（{{ unitList.length }}）</span>
            <button @click="createConstuctionUnit">添加施工单位</button>
        </div>
        <!-- 施工单位列表 -->
        <div class="unit-list">
            <ul>
                <li @click="changeSelectUnit(unit)" v-for="unit in unitList" :key="unit.id" :class="{ isSelect: unit.id == selectedUnitId }">
                    <ConstructionUnitItem :unitObj="unit"></ConstructionUnitItem>
                </li>
            </ul>
        </div>
        <ConstructionUnitReset ref="constructionUnitReset"></ConstructionUnitReset>
        <ConstructionUnitDelete ref="constructionUnitDelete" @updateUnitList="updateUnitList"></ConstructionUnitDelete>
        <ConstructionUnitPrompt ref="constructionUnitPrompt"></ConstructionUnitPrompt>
    </div>
</template>
<script>
import ConstructionUnitItem from './ConstructionUnitItem.vue';
import ConstructionUnitReset from './ConstructionUnitReset.vue';
import ConstructionUnitDelete from './ConstructionUnitDelete.vue';
import ConstructionUnitPrompt from './ConstructionUnitPrompt.vue';
export default {
    components: { ConstructionUnitItem, ConstructionUnitReset, ConstructionUnitDelete, ConstructionUnitPrompt },
    props: {
        unitList: {
            type: Array,
            default: []
        },
        selectedUnitId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            
        }
    },
    methods: {
        // 添加施工单位
        createConstuctionUnit() {
            this.$parent.addConstructionUnit()
        },
        // 切换施工单位
        changeSelectUnit(unit) {
            this.$parent.changeSelectUnit(unit)
        },
        // 重置密码
        resetPasswordAction(unitObj) {
            this.$refs.constructionUnitReset.showResetPassword(unitObj)
        },
        // 删除施工单位
        deleteUnitAction(unitObj) {
            if (unitObj.zkCount > 0) { 
                this.$refs.constructionUnitPrompt.showUnitPrompt()
            } else {
                this.$refs.constructionUnitDelete.showDeleteUnit(unitObj)
            }
        },
        // 删除施工单位成功后
        updateUnitList() {
            this.$parent.requestUnitList()
        },
        // 编辑施工单位
        editUnitAction(unitObj) {
            this.$parent.addConstructionUnit(unitObj)
        }
    },
}
</script>
<style scoped>
    .unit {
        width: 100%;
        height: 100%;
    }
    /* 头部标题和按钮 */
    .unit .unit-header {
        width: calc(100% - 40px);
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        height: 30px;
        margin: 18px 0 22px 0;
    }
    .unit .unit-header span {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181818;
        line-height: 28px;
    }
    .unit .unit-header button {
        width: 118px;
        height: 30px;
        background: #ECF5FF;
        border-radius: 6px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0054A0;
        line-height: 20px;
    }
    /* 列表 */
    .unit .unit-list {
        width: calc(100% - 40px);
        height: calc(100% - 90px);
        padding: 0 20px;
        overflow: scroll;
    }
    .unit .unit-list ul {
        width: 100%;
    }
    .unit .unit-list ul li {
        width: 100%;
        height: 128px;
        border-radius: 6px;
        border: 1px solid #EDEDED;
        margin-bottom: 12px;
    }
    .unit .unit-list ul li.isSelect {
        border: 2px solid #0054A0;
    }
</style>